import InitChatLink from '../../messageExtensions/links/InitChatLink'
import ResendLastMessageLink from '../../messageExtensions/links/ResendLastMessageLink'
import MessageLink from '../../messageExtensions/links/MessageLink'
import ReloadPageLink from '../../messageExtensions/links/ReloadPageLink'
import CommentLink from '../../messageExtensions/links/CommentLink'
import ContactSupport from '../../messageExtensions/blocks/ContactSupport'
import Copy from '../../messageExtensions/blocks/Copy'
import CommandButtons from '../../messageExtensions/blocks/CommandButtons'
import Confirmation from '../../messageExtensions/blocks/Confirmation'

import { ChatMessageExtensions } from '../../types'

const statsChatAssistantMessageExtensions: ChatMessageExtensions = {
  links: {
    '#init_chat': InitChatLink,
    '#new_chat': InitChatLink,
    '#resend_last_message': ResendLastMessageLink,
    '#message:': MessageLink,
    '#comments/': CommentLink,
    '#reload_page': ReloadPageLink
  },
  blocks: {
    contact_support: ContactSupport,
    copy: Copy,
    command_buttons: CommandButtons,
    confirmation: Confirmation
  }
}

export default statsChatAssistantMessageExtensions
